import { memo, useEffect, useRef, useState } from 'react';
import './csvTool.scss';
import { Divider, Row, Select, Space, Tag, Empty, Typography, Upload, Input, Button, message } from 'antd';
import stl from 'string-to-color';
// import { useListingCompanies } from '../../hooks/useCompanies';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { InboxOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons';
import {
    getPresignedUrl,
    useDownloadUpdatedCSV,
    useFetchCsvConfigList,
    useFetchCsvHeadersOnCompany,
    useSaveCsvConfig,
} from '../../hooks/useCsvOrder';
import AliasCard from './AliasCard';
import useLogout from '../../hooks/useLogout';
import axios from 'axios';
import SelectCompanyCode from '../../components/Planning/SelectCompany';
import stc from 'string-to-color';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';

const CsvTool = () => {
    const [companyCodeText, setCompanyCodeText] = useState('');
    const [isEligibleForAccess, setIsEligibleForAccess] = useState(false);
    const [aliasName, setAliasName] = useState('');
    const inputRef = useRef(null);
    const aliasInputRef = useRef(null);
    const { logout } = useLogout();
    // const [api, contextHolder] = notification.useNotification();
    const [sessionTags, setSessionTags] = useState([]);
    const [isUploadingCsv, setIsUploadingCsv] = useState(false);
    const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
    const [showAddAlias, setShowAddAlias] = useState(false);
    const [selectedFileKey, setSelectedKeyFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [companyConfigData, setCompanyConfigData] = useState([]);
    const [configsList, setConfigsList] = useState([]);
    const [isSaveConfig, setIsSaveConfig] = useState(false);
    const [configName, setConfigName] = useState('');
    const [isConfigSaving, setIsConfigSaving] = useState(false);
    const [selectedConfig, setSelectedConfig] = useState('');

    // const { data: companyCodeList } = useListingCompanies();

    const { data: staticHeadersList } = useFetchCsvHeadersOnCompany(companyCodeText);

    const { data: configsListData, refetch: refetchConfigList } = useFetchCsvConfigList(companyCodeText);

    const { mutate: getUpdatedCsv } = useDownloadUpdatedCSV(onSuccessResultant, onResultErr);

    const { mutate: saveCsvCofig } = useSaveCsvConfig(onSuccessConfigSave, onErrConfigSave);

    useEffect(() => {
        if (staticHeadersList?.data?.fields?.length > 0) {
            setIsEligibleForAccess(true);
        } else {
            if (companyCodeText) {
                message.info('There are no fields in the selected Company!');
                setCompanyCodeText('');
            }
        }
    }, [staticHeadersList?.data]);

    useEffect(() => {
        if (configsListData?.data?.configs?.length) {
            setConfigsList(configsListData?.data?.configs);
        }
    }, [configsListData?.data]);

    function onSuccessResultant(response) {
        console.log('first', response);
        var blob = new Blob([response.data], {
            type: response.headers['content-type'],
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];

        link.setAttribute('download', `${filename}.csv`);
        document.body.appendChild(link);
        link.click();
        setIsDownloadingCsv(false);
        resetPage();
        message.success('Updated successfully!');
    }

    function onResultErr(err) {
        console.log('first err', err);
        if (err?.response?.status === 401) logout();
        setIsDownloadingCsv(false);
    }

    function onSuccessConfigSave(response) {
        setConfigName('');
        setIsConfigSaving(false);
        setIsSaveConfig(false);
        refetchConfigList();
        message.success('Config saved successfully!');
    }

    function onErrConfigSave(err) {
        console.log('first err', err);
        if (err?.response?.status === 401) logout();
        setIsConfigSaving(false);
    }

    const resetPage = () => {
        setCompanyCodeText('');
        setAliasName('');
        setIsUploadingCsv(false);
        setIsDownloadingCsv(false);
        setSelectedKeyFile(null);
        setSelectedFileName('');
        setCompanyConfigData([]);
        setIsEligibleForAccess(false);
        setConfigName('');
        setConfigsList([]);
        setIsSaveConfig(false);
        setConfigName('');
        setIsConfigSaving(false);
        setSelectedConfig('');
        // message.success('Updated successfully!');
    };

    const addAlias = () => {
        let title = aliasName?.trim();
        if (!title) return;
        let tempConfig = [...companyConfigData];
        let duplicateIndex = tempConfig?.findIndex(el => el?.columnName?.toLowerCase() === title?.toLowerCase());
        if (duplicateIndex > -1) {
            message.info('Duplicates are not allowed!');
            return;
        }
        let newEntry = {
            columnName: title,
            dependency: [],
        };
        tempConfig?.push(newEntry);
        setAliasName('');
        setCompanyConfigData([...tempConfig]);
    };

    const onConfigChange = (name, { key }) => {
        if (configsList?.length > 0) {
            let configIndex = configsList?.findIndex(item => item?.name === name && item?._id === key);

            if (configIndex > -1) {
                let config = configsList[configIndex];
                if (config?.dependencies?.length > 0) {
                    setCompanyConfigData([...config?.dependencies]);
                }
                setSelectedConfig(name);
            }
        }
    };

    const showConfigSelector = () => {
        return (
            <div className="config_selector">
                <label htmlFor="configselect" style={{ fontSize: '15px' }}>
                    Select Config:
                </label>
                <Select
                    className=""
                    id="configselect"
                    size="medium"
                    style={{ width: '220px' }}
                    showSearch
                    placeholder="Select config"
                    onChange={(text, val) => onConfigChange(text, val)}
                    value={selectedConfig}
                >
                    {configsList?.map(el => {
                        return (
                            <Select.Option key={el._id} value={el.name}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                        flexDirection: 'row',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            alignItems: 'flex-start',
                                            width: '90%',
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <p
                                            style={{
                                                width: '95%',
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                alignItems: 'center',
                                                flexDirection: 'row',
                                            }}
                                        >
                                            <p
                                                style={{
                                                    backgroundColor: stc(el.createdBy.email),
                                                    width: '5px',
                                                    height: '100%',
                                                    marginRight: '5px',
                                                    minHeight: '20px',
                                                }}
                                            ></p>
                                            {el.name}
                                        </p>
                                        {el?.createdBy?.name ? (
                                            <p
                                                style={{
                                                    fontSize: '9px',
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'flex-end',
                                                    alignItems: 'center',
                                                    flexDirection: 'row',
                                                }}
                                            >
                                                <strong>created by:</strong>&nbsp;{el?.createdBy?.name}
                                            </p>
                                        ) : null}
                                    </div>
                                </div>
                            </Select.Option>
                        );
                    })}
                </Select>
            </div>
        );
    };

    const getHeader = () => {
        return (
            <div className="header_div">
                <Typography.Title level={4} style={{ margin: '0', padding: '0' }}>
                    {companyCodeText}{' '}
                    <Button
                        onClick={() => {
                            resetPage();
                        }}
                    >
                        <EditOutlined />
                    </Button>
                </Typography.Title>
            </div>
        );
    };

    const getConfigSelector = () => {
        return (
            <div className="config_selector_div">
                <div className="config_selector">{showConfigSelector()}</div>
            </div>
        );
    };

    const getFileExtension = file => {
        var fileName = file.name;
        return fileName.split('.').pop();
    };

    const handleImageUpload = async file => {
        let reqDataObj = {};
        let fileName = file?.name;
        reqDataObj.mimeType = file.type;
        reqDataObj.fileExtension = getFileExtension(file);
        reqDataObj.fname = fileName || '';
        if (reqDataObj.fileExtension.toLowerCase() !== 'csv') {
            reqDataObj = {};
            message.error('Please upload only csv file.');
            setSelectedFileName('');
            return;
        }
        setIsUploadingCsv(true);
        getPresignedUrl(reqDataObj)
            .then(resp => {
                axios.put(`${resp?.data?.url}`, file).then(async res => {
                    setSelectedKeyFile(resp?.data?.key);
                    setSelectedFileName(fileName);
                    setIsUploadingCsv(false);
                });
            })
            .catch(err => {
                console.log(err);
                if (err?.response?.status === 401) {
                    logout();
                }
                setIsUploadingCsv(false);
            });
    };

    const handleSaveResource = async () => {
        let updatePayload = {
            key: selectedFileKey,
            companyCode: companyCodeText,
            dependencies: [...companyConfigData],
        };

        setIsDownloadingCsv(true);
        getUpdatedCsv(updatePayload);
    };

    const onDragEnd = result => {
        if (result.destination) {
            let tempConfig = [...companyConfigData];
            let targetIndex = parseInt(result.destination.droppableId);
            let draggedName = result.draggableId;

            let draggableIndex = tempConfig[targetIndex].dependency?.findIndex(item => item === draggedName);
            if (draggableIndex < 0) {
                tempConfig[targetIndex].dependency.push(draggedName);
                setCompanyConfigData([...tempConfig]);
            }
        }
    };

    const checkSameConfigName = configName => {
        let isDisabled = false;
        if (configsList?.length > 0) {
            configsList?.forEach(item => {
                if (item?.name?.toLowerCase() === configName.toLowerCase()) {
                    isDisabled = true;
                }
            });
        }
        return isDisabled;
    };

    const handleSaveConfig = async () => {
        if (checkSameConfigName(configName)) {
            message.info('Config with given name is already present!');
            return;
        }

        let updatePayload = {
            name: configName,
            companyCode: companyCodeText,
            dependencies: [...companyConfigData],
        };
        setIsConfigSaving(true);
        saveCsvCofig(updatePayload);
    };

    const props = {
        name: 'file',
        multiple: false,
        maxCount: '1',
        onChange: async info => { },
        onDrop: () => { },
        customRequest: async ({ file }) => {
            await handleImageUpload(file);
        },
        style: {
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxHeight: '30%',
        },
        showUploadList: false,
        accept: '.csv',
    };

    const getCsvSection = () => {
        return (
            <div className="csv_section">
                <Typography.Title level={5} style={{ margin: 0, padding: 0 }}>
                    Upload Csv
                </Typography.Title>

                {!!selectedFileName ? (
                    <div className="selected_file_area">
                        <span
                            style={{
                                padding: '4px',
                                color: '#B0A695',
                                border: '2px solid #EBE3D5',
                                borderRadius: '3px',
                                background: '#FFFBF5',
                                overflow: 'auto',
                                textWrap: 'wrap',
                            }}
                        >
                            {selectedFileName}
                        </span>
                        <span style={{ position: 'absolute', right: '7px', top: '3px' }}>
                            <Button
                                onClick={() => {
                                    setSelectedKeyFile(null);
                                    setSelectedFileName('');
                                }}
                                type="text"
                                style={{ margin: 0, padding: 0, height: 'fit-content', border: 'none' }}
                            >
                                <CloseCircleOutlined
                                    style={{
                                        color: '#B0A695',
                                        background: '#FFFBF5',
                                    }}
                                />
                            </Button>
                        </span>
                    </div>
                ) : (
                    <Upload.Dragger {...props}>
                        <>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">Support for a single upload.</p>
                        </>
                    </Upload.Dragger>
                )}
            </div>
        );
    };

    const getHeadersSection = () => {
        return (
            <div className="csv_headers">
                <Typography.Title level={5} style={{ margin: 0, padding: 0 }}>
                    Fields
                </Typography.Title>
                <div className="headers_list">
                    {staticHeadersList?.data?.fields?.length > 0 ? (
                        <Droppable droppableId="name">
                            {provided =>
                                staticHeadersList?.data?.fields?.length > 0 ? (
                                    <Row className="container_box_main" gutter={[2, 2]}>
                                        {staticHeadersList?.data?.fields?.map((tag, i) => (
                                            <div ref={provided.innerRef} {...provided.droppableProps} key={`${tag}${i}`}>
                                                <Draggable draggableId={tag} index={i}>
                                                    {(provided, snapshot) => (
                                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                            <Tag className="pointer">
                                                                {tag}
                                                                {provided.placeholder}
                                                            </Tag>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            </div>
                                        ))}
                                    </Row>
                                ) : null
                            }
                        </Droppable>
                    ) : (
                        <Row className="content_center container_box">
                            <Typography.Text type="secondary">No header to show</Typography.Text>
                        </Row>
                    )}
                </div>
            </div>
        );
    };

    const handleRemoveColumn = colIndex => {
        let tempConfig = [...companyConfigData];
        let newConfig = tempConfig?.filter((item, index) => index !== colIndex);
        setCompanyConfigData([...newConfig]);
    };

    const handleRemoveName = (colIndex, rowIndex) => {
        let tempConfig = [...companyConfigData];
        let columnArrayData = tempConfig[colIndex]?.dependency;
        let newDependencies = columnArrayData?.filter((item, index) => index !== rowIndex);
        tempConfig[colIndex]['dependency'] = [...newDependencies];
        setCompanyConfigData([...tempConfig]);
    };

    const getDroppableSectionOfBoxes = () => {
        return (
            <div className="boxes_section">
                {companyConfigData?.length > 0 ? (
                    <Row className="container_box" gutter={[0, 8]}>
                        {companyConfigData?.map((column, i) => (
                            <Droppable droppableId={`${i}`} index={i} key={i}>
                                {provided => (
                                    <div ref={provided.innerRef}>
                                        <AliasCard
                                            key={i}
                                            handleRemoveColumn={handleRemoveColumn}
                                            column={column}
                                            handleRemoveName={handleRemoveName}
                                            currentIndex={i}
                                        />
                                    </div>
                                )}
                            </Droppable>
                        ))}
                    </Row>
                ) : (
                    <Row className="content_center container_box">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </Row>
                )}
            </div>
        );
    };

    const getDependencyDisabled = () => {
        let isDisabled = false;
        if (companyConfigData?.length > 0) {
            [...companyConfigData]?.forEach(item => {
                if (item?.dependency?.length === 0) {
                    isDisabled = true;
                }
            });
        }

        if (companyConfigData?.length === 0) {
            isDisabled = true;
        }

        return isDisabled;
    };

    const getUpdateButtonSection = () => {
        return (
            <div className="update_button_section">
                <Button
                    size="small"
                    onClick={() => {
                        setIsSaveConfig(true);
                    }}
                    type="default"
                    disabled={getDependencyDisabled()}
                // loading={isUploadingCsv || isDownloadingCsv}
                >
                    Save configuration
                </Button>
                <Button
                    size="small"
                    onClick={handleSaveResource}
                    type="primary"
                    disabled={!selectedFileKey || getDependencyDisabled()}
                    loading={isUploadingCsv || isDownloadingCsv}
                >
                    Update
                </Button>
            </div>
        );
    };

    return (
        <>
            {!companyCodeText || !isEligibleForAccess ? (
                <SelectCompanyCode onCompanyCodeSelected={setCompanyCodeText} isCsvTool={true} />
            ) : (
                <div className="tool_container">
                    {getHeader()}
                    <hr style={{ margin: '0', padding: '0' }} />
                    {getCsvSection()}
                    {getConfigSelector()}
                    <DragDropContext onDragEnd={onDragEnd}>
                        <div className="dragger_container">
                            <div className="dragger_left_section">{getHeadersSection()}</div>
                            <div className="dragger_right_section">
                                <Row className="alias_input">
                                    <Typography.Title level={5} style={{ margin: 0, padding: 0 }}>
                                        {' '}
                                        Dependency Mapping{' '}
                                    </Typography.Title>
                                    <Space direction="horizontal">
                                        <Input
                                            placeholder="Add Alias"
                                            allowClear
                                            size="small"
                                            value={aliasName}
                                            onChange={e => setAliasName(e?.target?.value)}
                                        />
                                        <Button style={{ width: 80 }} size="small" onClick={addAlias} disabled={!aliasName?.trim()}>
                                            Add
                                        </Button>
                                    </Space>
                                </Row>
                                {getDroppableSectionOfBoxes()}
                            </div>
                        </div>
                    </DragDropContext>
                    {getUpdateButtonSection()}
                </div>
            )}
            {isSaveConfig ? (
                <DynamicModal
                    open={isSaveConfig}
                    closable={true}
                    close={() => setIsSaveConfig(false)}
                    width={'30%'}
                    overflow="auto"
                    component={
                        <>
                            <div
                                className="save_configuration"
                                style={{
                                    minHeight: '100px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    padding: '5px',
                                }}
                            >
                                <div>
                                    <label htmlfor="">Configuration Name: </label> &nbsp;
                                    <Input
                                        value={configName}
                                        onChange={e => setConfigName(e?.target?.value)}
                                        style={{ width: '250px' }}
                                        placeholder="Enter configuration name"
                                    />
                                </div>
                                <div
                                    className="cofiguration_save_div"
                                    style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '1rem', gap: '3px' }}
                                >
                                    <Button
                                        size="small"
                                        onClick={() => {
                                            setConfigName('');
                                            setIsSaveConfig(false);
                                        }}
                                        type="default"
                                    // disabled={!selectedFileKey || getDependencyDisabled()}
                                    // loading={isUploadingCsv || isDownloadingCsv}
                                    >
                                        Cancel
                                    </Button>
                                    <Button size="small" onClick={handleSaveConfig} type="primary" disabled={!configName} loading={isConfigSaving}>
                                        Update
                                    </Button>
                                </div>
                            </div>
                        </>
                    }
                    title="Save Configuration"
                />
            ) : null}
        </>
    );
};

export default memo(CsvTool);
